import Vue from 'vue'
import router from '../router'
import store from '../store'

import { mapState } from 'vuex'
Vue.prototype.get_loading = false
Vue.mixin({
    methods: {
        toaster:(msg, t) => {
            Vue.toasted.show(msg, {
            singleton: true,
            type : t != 200 ? 'error' : 'success',
            icon : t != 200 ? 'error_outline' : 'check_circle_outline',
            position: 'bottom-center',
            duration: 3000,
            });
        },
        get_user:() => {
            axios.get('/api/user/info', {}).then(res =>
            {
                store.commit('store_user', res.data)
            })
            .catch(err =>
            {
                this.toaster('something went wrong.', 201);
                router.push('/login')
            }).finally(()=>{
            })
        },
        numberWithCommas(x) {
            return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        formatDate(date) {
            var hours = date.getHours();
            var minutes = date.getMinutes();
            var ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            minutes = minutes < 10 ? '0'+minutes : minutes;
            var strTime = hours + ':' + minutes + ' ' + ampm;
            return date.getMonth()+1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
        },

    },
    computed: {
        ...mapState({
            user:       state => state.user,
            countries:  state => state.countries,
            company:    state => state.company,
            currencies: state => state.currencies,
            pages:      state => state.pages,
            get_response: state => state.get_response
        }),
    },
    mounted () {
    }
})